export const mapItems = (item: { id: string; Component: JSX.Element }) => ({
  id: item.id,
  x: 0,
  y: 0,
  Component: item.Component,
});

export const getCount = (
  listRef: HTMLCollectionOf<HTMLElement>,
  index: number,
  y: number,
) => {
  const isUp = y < 0;
  const traveled = Math.round(Math.abs(y));

  const heights: number[] = [];
  // TODO remove 'any' cast after tsconfig adds 'dom.iterable'
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  for (const child of listRef as any) {
    heights.push(child.offsetHeight);
  }
  const subset = isUp
    ? heights.slice(0, index).reverse()
    : heights.slice(index, heights.length);

  const getSum = (ind: number) => {
    const sum = subset.slice(0, ind + 1).reduce((a, b) => a + b, 0);
    const card = isUp ? 0 : heights[index];
    const diff = isUp
      ? subset[ind] / 2
      : (subset[ind + 1] || subset[subset.length - 1]) / -2;
    return sum - card - diff;
  };

  return (
    subset.findIndex((height, idx) => {
      const length = subset.length - 1;
      const total = getSum(length);
      const sum = getSum(idx);
      const limit = getSum(idx < length ? idx + 1 : length);
      const isCount = sum <= traveled && limit > traveled;
      const isLimit = idx === subset.length - 1 && traveled >= total;
      return isCount || isLimit;
    }) + 1
  );
};
